export const claimErrorMessage = {
    RECONNECT_TWITTER_ACCOUNT: 'Please reconnect your Twitter account to claim this quest.',
    TWITTER_ACCOUNT_NOT_LINKED: 'Your account is not linked to your twitter profile',
    TWITTER_ACCOUNT_SUSPENDED: 'Your Twitter account is suspended or locked, please login to Twitter and claim the quest again.',
    TOO_MANY_INCORRECT_SUBMISSIONS: 'Your Twitter account was disconnected due to multiple failed attempts. Please wait a bit, then reconnect your Twitter account and try again.',
};
